import reactCert from '../assets/images/Certification react js course.jpeg';
import designAppCert from '../assets/images/Certification design app.jpeg';
import uxUiCert from '../assets/images/Certification ux ui designer.jpeg';
import designThinkingCert from '../assets/images/Certification Design thinking.jpeg';
import salesforceAssociateCert from '../assets/images/Certification salesforce associate.jpeg';
import salesforceDevCert from '../assets/images/Certification Developpeur salesforce.jpeg';

export const certificationCategories = {
  dev: { fr: 'Développement', en: 'Development' },
  salesforce: { fr: 'Salesforce', en: 'Salesforce' },
  design: { fr: 'Design & UX', en: 'Design & UX' },
};

export const certifications = [
  {
    id: 'javascript-dev',
    title: 'JavaScript Developer',
    description: 'Certification en développement JavaScript avancé et bonnes pratiques front-end.',
    descriptionEn: 'Advanced JavaScript development and front-end best practices certification.',
    image: reactCert,
    category: 'dev',
    issuer: 'Meta',
    year: '2023',
    topics: ['JavaScript', 'ES6+', 'React'],
  },
  {
    id: 'salesforce-associate',
    title: 'Salesforce Certified Associate',
    description: 'Fondamentaux de la plateforme Salesforce et écosystème cloud CRM.',
    descriptionEn: 'Salesforce platform fundamentals and cloud CRM ecosystem.',
    image: salesforceAssociateCert,
    category: 'salesforce',
    issuer: 'Salesforce',
    year: '2024',
    topics: ['CRM', 'Cloud', 'Admin'],
  },
  {
    id: 'salesforce-dev',
    title: 'Salesforce Developer I',
    description: "Développement d'applications métier sur Salesforce : Apex, LWC et intégrations.",
    descriptionEn: 'Business application development on Salesforce: Apex, LWC and integrations.',
    image: salesforceDevCert,
    category: 'salesforce',
    issuer: 'Salesforce',
    year: '2024',
    topics: ['Apex', 'LWC', 'API'],
  },
  {
    id: 'design-thinking',
    title: 'Design Thinking',
    description: 'Méthodologie centrée utilisateur pour résoudre des problèmes complexes.',
    descriptionEn: 'User-centered methodology for solving complex product problems.',
    image: designThinkingCert,
    category: 'design',
    issuer: 'IDEO U',
    year: '2023',
    topics: ['Recherche', 'Idéation', 'Prototype'],
  },
  {
    id: 'ux-ui',
    title: 'UI/UX Designer',
    description: "Conception d'interfaces claires, accessibles et orientées conversion.",
    descriptionEn: 'Designing clear, accessible and conversion-oriented interfaces.',
    image: uxUiCert,
    category: 'design',
    issuer: 'Google UX',
    year: '2023',
    topics: ['UI', 'UX', 'Figma'],
  },
  {
    id: 'app-design',
    title: "Design d'Applications",
    description: "Création d'expériences mobiles et web cohérentes de bout en bout.",
    descriptionEn: 'End-to-end cohesive mobile and web application experiences.',
    image: designAppCert,
    category: 'design',
    issuer: 'Coursera',
    year: '2023',
    topics: ['Mobile', 'Web', 'Design system'],
  },
];
